export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "delivery_process_provider": {
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])}
          }
        }
      }
    }
  })
}